import { createSelector } from "reselect";
import { AppState } from "app/shared/store/root.reducer";

const getStore = (state: AppState) => state.topUp;
const getResponseMakeFee = (state: AppState) => state.topUp.responseMakeFee;
const getResponseInfo = (state: AppState) => state.topUp.responseInfo;
const getTopUpInfoPending = (state: AppState) => state.topUp.pendingInfo;
const getIsCheckedCustomer = (state: AppState) => state.topUp.isCheckedCustomer;
const getResCustomerInfo = (state: AppState) => state.topUp.customerInfo;
const getDataCreate = (state: AppState) => state.topUp.dataCreate;
const getResponseCreated = (state: AppState) => state.topUp.responseCreate;
const getResponseConfirm = (state: AppState) => state.topUp.responseConfirm;
const getResponseAuth = (state: AppState) => state.topUp.responseAuth;

export const getTopUpStoreSelector = createSelector(getStore, (data) => data);
export const getTopUpInfoSelector = createSelector(getResponseInfo, (info) => info);
export const getTopUpInfoPendingSelector = createSelector(getTopUpInfoPending, (status) => status);
export const getTopUpMakeFeeSelector = createSelector(getResponseMakeFee, (fee) => fee);

export const getTopUpCustomerIsCheckedSelector = createSelector(getIsCheckedCustomer, (status) => status);
export const getTopUpResCustomerInfoSelector = createSelector(getResCustomerInfo, (customer) => customer);

export const getTopUpDataCreateSelector = createSelector(getDataCreate, (data) => data);

export const getTopUpResponseCreatedSelector = createSelector(getResponseCreated, (res) => res);

export const getTopUpResponseConfirmSelector = createSelector(getResponseConfirm, (res) => res);

export const getTopUpResponseAuthSelector = createSelector(getResponseAuth, (res) => res);
